const envNumber = (value, fallback) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const envString = (value, fallback) => (
  typeof value === 'string' && value.trim() !== '' ? value : fallback
);

export const DRIVE_SPEED_KMH = envNumber(
  process.env.REACT_APP_DRIVE_SPEED_KMH,
  50,
);

export const DEFAULT_CENTER = {
  lat: envNumber(process.env.REACT_APP_DEFAULT_LAT, 45.5017),
  lng: envNumber(process.env.REACT_APP_DEFAULT_LNG, -73.5673),
};

export const GEOAPIFY_COUNTRY_CODE = envString(
  process.env.REACT_APP_GEOAPIFY_COUNTRY_CODE,
  'ca',
);

export const GEOAPIFY_RESULT_LIMIT = envNumber(
  process.env.REACT_APP_GEOAPIFY_LIMIT,
  50,
);

export const SUPPORT_EMAIL = envString(
  process.env.REACT_APP_SUPPORT_EMAIL,
  'support@neobox.com',
);

export const PARTNER_EMAIL = envString(
  process.env.REACT_APP_PARTNER_EMAIL,
  'partners@neobox.com',
);

export const DOCUMENTATION_URL = envString(
  process.env.REACT_APP_DOCUMENTATION_URL,
  'https://documentation.neobox.io/',
);

export const SOCIAL_LINKS = {
  instagram: envString(process.env.REACT_APP_SOCIAL_INSTAGRAM, 'https://www.instagram.com/neobox.inc/'),
  facebook: envString(process.env.REACT_APP_SOCIAL_FACEBOOK, 'https://www.facebook.com/neobox.io/'),
  twitter: envString(process.env.REACT_APP_SOCIAL_TWITTER, 'https://x.com/Neobox_Inc'),
  linkedin: envString(process.env.REACT_APP_SOCIAL_LINKEDIN, 'https://www.linkedin.com/company/neoboxsupply/'),
  youtube: envString(process.env.REACT_APP_SOCIAL_YOUTUBE, 'https://www.youtube.com/@neobox7385'),
};

export const CAROUSEL = {
  bannerAutoplayMs: envNumber(process.env.REACT_APP_CAROUSEL_BANNER_DELAY_MS, 2300),
  bannerSpeedMs: envNumber(process.env.REACT_APP_CAROUSEL_BANNER_SPEED_MS, 375),
  hotAutoplayMs: envNumber(process.env.REACT_APP_CAROUSEL_HOT_DELAY_MS, 3500),
  featuredScrollPx: envNumber(process.env.REACT_APP_FEATURED_SCROLL_PX, 300),
};
